<div class="admin-container">
    <form class="form">
        <div class="input-group">
            <label>Id du Post Instagram:</label>
            <input pInputText [(ngModel)]="sectionData.postId" name="postId">
        </div>
    </form>
</div>